import axios from 'axios';
import {getHeader} from './user_api';
import { COMPANY_PRICELIST_URL} from '../constants/api_routes';

export const getCompanyPriceList = async (id, type) => {
    // try {
    //     const res = await axios.get(`${COMPANY_PRICELIST_URL}?id=${id}&inspection_type=${type}`, {headers: getHeader()});
    //     return ({
    //             priceData: res.data,
    //             errorMessage: undefined
    //         }
    //     );

    // } catch (error) {
    //     return ({
    //         success: false,
    //         responseMessage: "Something went wrong. Try again.",
    //         status:error.response.status
    //     });
    // }
};

export const getPriceLists = async () => {
    try {
        const res = await axios.get(`${COMPANY_PRICELIST_URL}/list`, {headers: getHeader()});
        return ({
                priceData: res.data,
                errorMessage: undefined
            }
        );

    } catch (error) {
        return ({
            success: false,
            responseMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const deleteList = async (id) => {
    try {
        const res = await axios.delete(`${COMPANY_PRICELIST_URL}/${id}`, { headers: getHeader() });
        return {
            success: true,
            responseMessage: res.data.message
        };
    } catch (error) {
        return {
            success: false,
            responseMessage:"Something went wrong. Try again.",
            status: error.response.status
        };
    }
};

export const updateList = async (payload) => {
    try {
        const res = await axios.put(
            `${COMPANY_PRICELIST_URL}/update`,
            payload,
            { headers: getHeader() }
        );
        return {
            success: true,
            responseMessage: res.data.message,
            data: res.data
        };
    } catch (error) {
        return {
            success: false,
            responseMessage: (error.response && error.response.data && error.response.data.message) 
                ? error.response.data.message 
                : "Something went wrong. Try again.",
            status: error.response ? error.response.status : undefined
        };
    }
};


export const updateCompanyPriceList = async (priceId, price) => {
    // try {
    //     await axios.put(`${COMPANY_PRICELIST_URL}`, {id: priceId, price: price}, {headers: getHeader()});
    //     return ({
    //             success: true,
    //             responseMessage: "Successfully Updated",
    //         }
    //     );

    // } catch (error) {
    //     return ({
    //         success: false,
    //         responseMessage: "Something went wrong. Try again.",
    //         status:error.response.status
    //     });
    // }
};

export const getClerkPriceList = async (type) => {
    // try {
    //     const res = await axios.get(`${CLERK_PRICELIST_URL}?inspection_type=${type}`, {headers: getHeader()});
    //     return ({
    //             priceData: res.data,
    //             errorMessage: undefined
    //         }
    //     );

    // } catch (error) {
    //     return ({
    //         success: false,
    //         responseMessage: "Something went wrong. Try again.",
    //         status:error.response.status
    //     });
    // }
};

export const updateClerkPriceList = async (priceId, price) => {
    // try {
    //     await axios.put(`${CLERK_PRICELIST_URL}`, {id: priceId, price: price}, {headers: getHeader()});
    //     return ({
    //             success: true,
    //             responseMessage: "Successfully Updated",
    //         }
    //     );

    // } catch (error) {
    //     return ({
    //         success: false,
    //         responseMessage: "Something went wrong. Try again.",
    //         status:error.response.status
    //     });
    // }
};

export const bulkUpdateCompanyPriceList = async (formData) => {
    // try {
    //     await axios.post(`${COMPANY_PRICELIST_URL}/upload`,formData,{headers:getHeader()});
    //     return ({
    //         success:true,
    //         responseMessage:"Successfully updated"
    //     });
    // }
    // catch (e) {
    //     return ({
    //         success:false,
    //         responseMessage:"Something went wrong.Try again."
    //     });
    // }
};


// WEBPACK FOOTER //
// ./src/data/price_list_api.js